<template>
<div>
    <!-- 页面内容将在这里渲染 -->
    <NuxtPage />
  </div>
</template>
